import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../css/menuiconlyer.css";
import "../css/getintouch.css";
import pinImage from "../assets/images/header/paper-clip_2115630.png";
import { motion } from "framer-motion";
import { HashLink } from "react-router-hash-link";
import leftArrow from "../assets/icons/left-arrow.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SubSpecialitiesInfo from "../data/SubSpecialitiesInfo";
import ProceduresData from "../data/proceduresData";
// import PaymentIcon from "../assets/icons/MenuIcons/cash-01.png";
import AppointmentIcon from "../assets/icons/MenuIcons/time-frame-01.png";
import ExamPrepIcon from "../assets/icons/MenuIcons/assignment-01.png";
import PatientFormIcon from "../assets/icons/MenuIcons/document-01.png";
import BillingInsuIcon from "../assets/icons/MenuIcons/life-insurance-01.png";
import MedicalRecordsIcon from "../assets/icons/MenuIcons/medical-data-01.png";
import PatientResourceIcon from "../assets/icons/MenuIcons/investigator-01.png";
// import satisfactionIcon from "../assets/icons/MenuIcons/social-01.png";
import ReviewsIcon from "../assets/icons/MenuIcons/rating-01.png";

import cliniansIcon from "../assets/icons/MenuIcons/open-enrollment-01.png";
import abbadox from "../assets/icons/MenuIcons/abbadox.png";
import attornyimg from "../assets/icons/imaging-accreditation/license_17371664 (1).png";
import Logo from "../assets/icons/imaging-accreditation/cdc_copy_new.png";
import BodyImagingIcon from "../assets/icons/MenuIcons/injury.png";
export default function Header() {
  const [isImagingOpen, setIsImagingOpen] = useState(false);
  const [isPatientOpen, setIsPatientOpen] = useState(false);
  const [isCliniciansOpen, setIsCliniciansOpen] = useState(false);
  const [isAttorneyOpen, setIsAttorneyOpen] = useState(false);
  const [topNav, setTopNav] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [specialityValue, setSpecialityValue] = useState(null);
  const [subDropDown, setSubDropDown] = useState(null);
  const [activeSubDropDown, setActiveSubDropDown] = useState(null);
  const companyTimeoutRef = useRef(null);
  const patientTimeoutRef = useRef(null);
  const cliniciansTimeoutRef = useRef(null);
  const attorneyTimeoutRef = useRef(null);
  // const navigate = useNavigate();
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };
  function getDropdownClass(item) {
    switch (item.text.toLowerCase()) {
      case "clinicians":
        return "2xl:-right-[19rem] -right-[15rem] top-[1rem] xl:top-[2rem]";
      case "services":
        return "-right-[12rem] xl:-right-[14rem] lg:top-[0rem] 2xl:-right-[17rem] px-4 xl:px-8 xl:top-[2rem]";
      default:
        return "2xl:-left-[320px] -left-[260px] -top-20 xl:top-4 2xl:top-8";
    }
  }
  const baseClasses =
    "absolute max-w-72 min-w-40 text-sm bg-black text-white shadow-lg p-4 font-robout font-black rounded-lg pointer-events-auto";
  const isVisible = activeDropdown && window.innerWidth >= 1024;
  const visibilityClass = isVisible ? "xl:block" : "hidden";
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  const wordVariants = {
    hidden: { x: 100, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 15,
        delay: i * 0.05,
      },
    }),
  };
  const dropdownVariants = {
    hidden: {
      opacity: 0,
      x: 20,
      rotate: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      x: 0,
      rotate: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };
  const mobileDropdownVariants = {
    hidden: {
      opacity: 0,
      height: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      height: "auto",
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };
  const subspeciality = [
    {
      id: 7,
      name: "Auto/Personal Injury Imaging",
      link: "/services/subspecialities/personal-injury-imaging",
    },
    {
      id: 1,
      name: "Chest/Body Imaging",
      link: "/services/subspecialities/body-imaging",
    },
    {
      id: 2,
      name: "Cardiac Imaging",
      link: "/services/subspecialities/cardiac-imaging",
    },
    {
      id: 3,
      name: "Men's Imaging",
      link: "/services/subspecialities/mens-imaging",
    },
    {
      id: 4,
      name: "Musculoskeletal Imaging",
      link: "/services/subspecialities/musculoskeletal-imaging",
    },
    {
      id: 5,
      name: "Neurology Imaging",
      link: "/services/subspecialities/neurology-imaging",
    },
    {
      id: 6,
      name: "Oncology Imaging",
      link: "/services/subspecialities/oncology-imaging",
    },
    {
      id: 8,
      name: "Vascular Imaging",
      link: "/services/subspecialities/vascular-imaging",
    },
    {
      id: 9,
      name: "Women's Imaging",
      link: "/services/subspecialities/women-imaging",
    },
  ];
  const procedurs = [
    {
      id: 1,
      name: "2D/3D Mammography",
      link: "/services/tests/3D-mammography",
    },
    {
      id: 3,
      name: "Cardiac/Body Nuclear Medicine",
      link: "/services/tests/cardiac-general-nuclear-medicine",
    },
    {
      id: 5,
      name: "Digital X-Ray",
      link: "/services/tests/digital-xray",
    },
    {
      id: 6,
      name: "Echocardiograpgy",
      link: "/services/tests/echocardiography",
    },
    {
      id: 2,
      name: "General/Vascular Ultrasound",
      link: "/services/tests/ultrasound",
    },
    {
      id: 7,
      name: "High-Field/Open MRI",
      link: "/services/tests/open-mri-scan",
    },
    {
      id: 8,
      name: "Low Dose 160-Slice Open CT",
      link: "/services/tests/low-dose-open-ct-scan",
    },
    {
      id: 4,
      name: "Osteoporosis DEXA Scan",
      link: "/services/tests/dexa-bone-desnity-scan",
    },
    {
      id: 9,
      name: "PET/CT-Scan",
      link: "/services/tests/pet-ct-scan",
    },
  ];
  const patientsDropdown = [
    { text: "Request Appointment", link: "/for-patient#appointment" },
    { text: "Exam Prep", link: "/for-patient#exam-prep" },
    { text: "Patient Forms", link: "/for-patient#forms" },
    { text: "Billing & Insurance", link: "/for-patient#insurance" },
    { text: "Patient Portal", link: "/for-patient#abbadox-portal" },
    { text: "Patient Resources", link: "/for-patient#patient-resources" },
    { text: "Patient Reviews", link: "/patient-reviews" },
  ];
  const cliniciansDropdown = [
    { text: "Physician Order Form", link: "/for-clinicians#form" },
    { text: "Physician Portal", link: "/for-clinicians#abbadox-portal" },
    {
      text: "PACS Portal",
      link: "https://us.synthos.health/",
    },
    { text: "Medical Records", link: "/medical-records" },
    { text: "Clinician Resources", link: "/for-clinicians#resources" },
  ];
  const attorneyDropdown = [
    {
      text: "Auto/Personal Injury Imaging",
      link: "/services/subspecialities/personal-injury-imaging",
    },
    { text: "Attorney Portal", link: "/for-clinicians#form" },
    { text: "Medical Records", link: "/medical-records" },
  ];
  const menuItems = [
    { text: "home", chars: ["H", "o", "m", "e"], link: "/" },
    { text: "about", chars: ["A", "b", "o", "u", "t"], link: "/about" },
    {
      text: "services",
      chars: ["S", "e", "r", "v", "i", "c", "e", "s"],
      dropdown: [
        { text: "Subspecialities", link: "/services" },
        { text: "Tests", link: "/services" },
      ],
      link: "/services",
    },
    {
      text: "patients",
      chars: ["P", "a", "t", "i", "e", "n", "t", "s"],
      dropdown: patientsDropdown,
    },
    {
      text: "clinicians",
      chars: ["C", "l", "i", "n", "i", "c", "i", "a", "n", "s"],
      dropdown: cliniciansDropdown,
      link: "/for-clinicians",
    },
    {
      text: "Attorney",
      chars: ["A", "t", "t", "o", "r", "n", "e", "y"],
      dropdown: attorneyDropdown,
      link: "/attorney",
    },
  ];
  const handleCompanyLinkClick = () => {
    clearTimeout(companyTimeoutRef.current);
    setIsImagingOpen(false);
  };
  const handlePatientLinkClick = () => {
    clearTimeout(patientTimeoutRef.current);
    setIsPatientOpen(false);
  };
  const handleCliniciansLinkClick = () => {
    clearTimeout(cliniciansTimeoutRef.current);
    setIsCliniciansOpen(false);
  };
  const handleAttorneyLinkClick = () => {
    clearTimeout(attorneyTimeoutRef.current);
    setIsAttorneyOpen(false);
  };
  const handleCompanyMouseLeave = () => {
    companyTimeoutRef.current = setTimeout(() => {
      setIsImagingOpen(false);
    }, 300);
  };
  const handlePatientMouseLeave = () => {
    patientTimeoutRef.current = setTimeout(() => {
      setIsPatientOpen(false);
    }, 300);
  };
  const handleCliniciansMouseLeave = () => {
    cliniciansTimeoutRef.current = setTimeout(() => {
      setIsCliniciansOpen(false);
    }, 300);
  };
  const handleAttorneyMouseLeave = () => {
    attorneyTimeoutRef.current = setTimeout(() => {
      setIsAttorneyOpen(false);
    }, 300);
  };
  const handleCompanyMouseEnter = () => {
    clearTimeout(companyTimeoutRef.current);
    setIsImagingOpen(true);
  };
  const handlePatientMouseEnter = () => {
    clearTimeout(patientTimeoutRef.current);
    setIsPatientOpen(true);
  };
  const handleCliniciansMouseEnter = () => {
    clearTimeout(cliniciansTimeoutRef.current);
    setIsCliniciansOpen(true);
  };
  const handleAttorneyMouseEnter = () => {
    clearTimeout(attorneyTimeoutRef.current);
    setIsAttorneyOpen(true);
  };
  useEffect(() => {
    const applyBodyClass = () => {
      const isLaptop = window.innerWidth >= 1024;
      if (topNav && isLaptop) {
        document.body.classList.add("offcanvas-open");
      } else {
        document.body.classList.remove("offcanvas-open");
      }
    };

    // run on mount and whenever topNav changes
    applyBodyClass();

    // handle window resize so the class updates if viewport crosses the breakpoint
    const onResize = () => applyBodyClass();
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      document.body.classList.remove("offcanvas-open"); // cleanup
    };
  }, [topNav]);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleMouseEnter = (index) => {
    if (window.innerWidth >= 1024) {
      setActiveDropdown(index);
    }
  };
  const handleMouseLeave = (index) => {
    if (window.innerWidth >= 1021) {
      setActiveDropdown((prev) => (prev === index ? null : prev));
    }
  };
  const handleDropdownToggle = (index) => {
    if (window.innerWidth < 1024) {
      setActiveDropdown((prev) => (prev === index ? null : index));
    }
  };
  return (
    <div>
      {!isScrolled && (
        <div className="z-30">
          <div className="bg-[#ffffff] w-full z-50 hidden xl:flex items-center ">
            <div className="max-w-7xl  mx-auto  flex justify-between gap-8">
              {/* LEFT SIDE — PHONE / FAX / ADDRESS / BUTTON */}
              <div>
                <Link to="/" aria-label="Citrus Diagnostic Center">
                  <img
                    src={Logo}
                    alt="Citrus Diagnostic Center"
                    className="w-[150px] h-auto"
                  />
                </Link>
              </div>

              {/* RIGHT SIDE — LOGO */}
              <div className="flex gap-5 2xl:gap-8  items-center justify-start text-[#2a0a1c] font-robout">
                <div className="flex gap-2">
                  <p>Phone:</p>
                  <Link to="tel:3524508062" aria-label="Phone Number">
                    (352) 450-8062
                  </Link>
                </div>

                <div className="flex gap-2">
                  <p>Fax:</p>
                  <Link to="" aria-label="Fax Number">
                    352-795-6460
                  </Link>
                </div>

                <div className="flex gap-2">
                  <p>Address:</p>
                  <Link
                    to="https://maps.app.goo.gl/8ZXLiVbW66AXjTQn9"
                    target="_blank"
                    aria-label="Address"
                  >
                    922 N Citrus Ave, United States
                  </Link>
                </div>
                <div>
                  <Link to="/contact" aria-label="Contact Us">
                    Contact
                  </Link>
                </div>

                {/* Button */}
                <div className="">
                  <a
                    href="/make-a-payment"
                    className="nav-cta button button-outlined"
                    data-button-svg=""
                  >
                    <span className="button-inner pe-1 z-10">
                      <span className="button-inner-static text-lg bg-transparent text-center">
                       Bill Pay
                      </span>
                      <span className="button-inner-hover text-lg bg-transparent text-center">
                        Bill Pay
                      </span>
                    </span>
                    <span>
                      <svg
                        style={{
                          backgroundColor: "transparent !important",
                        }}
                        className="button-outlined-bg "
                        enableBackground="new 0 0 153.81333333333333 56"
                        viewBox="0 0 153.81333333333333 56"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <clipPath id="buttonSvg_U5NPDA2Q2">
                          <path
                            className="button-stroke"
                            style={{ 
                              transform: "scale(0.95)",
                            }}
                            d="m125.81333333333333 1c14.9 0 27 12.1 27 27s-12.1 27-27 27h-97.81333333333333c-14.9 0-27-12.1-27-27s12.1-27 27-27zm0-1h-97.81333333333333c-15.5 0-28 12.5-28 28 0 15.5 12.5 28 28 28h97.81333333333333c15.5 0 28-12.5 28-28 0-15.5-12.5-28-28-28z"
                          />
                        </clipPath>
                        <g clipPath="url(#buttonSvg_U5NPDA2Q2)">
                          <g className="button-circles">
                            <g className="button-circles-o">
                              <circle
                                pathLength="1"
                                className="button-circle -layer-1"
                                strokeWidth="153.81333333333333"
                                cx="76.906"
                                cy="28"
                                r="76.906"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-2"
                                strokeWidth="153.81333333333333"
                                cx="76.906"
                                cy="28"
                                r="76.906"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-3"
                                strokeWidth="153.81333333333333"
                                cx="76.906"
                                cy="28"
                                r="76.906"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-4"
                                strokeWidth="153.81333333333333"
                                cx="76.906"
                                cy="28"
                                r="76.906"
                              />
                            </g>
                            <circle
                              pathLength="1"
                              className="button-circle -hover"
                              strokeWidth="153.81333333333333"
                              cx="76.906"
                              cy="28"
                              r="76.906"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className=" flex justify-end mr-7">
              <button
                onClick={() => {
                  setActiveDropdown(null);
                }}
                aria-label={topNav ? "Close menu" : "Open menu"} // ⭐ FIX HERE
                className="xiubfib vklmzv rounded-full bg-red-400 cursor-pointer z-40"
              >
                <span className="qopmxk rounded-full">
                  <span
                    className={`uweytn rounded-full ${
                      topNav ? "bg-white" : "bg-[#bf9c5e]"
                    }`}
                  >
                    <span className="vwuewq z-purple rounded-full"></span>
                    <span className="vwuewq z-turquoise rounded-full"></span>
                    <span className="vwuewq z-yellow rounded-full"></span>
                  </span>
                </span>
                <span className="qkxjwn rounded-full">
                  <span className="static-xt">
                    <label className="menuButton" htmlFor="check">
                      <input
                        type="checkbox"
                        id="check"
                        checked={topNav}
                        onChange={() => {
                          setTopNav(!topNav);
                          setSpecialityValue(null);
                        }}
                      />
                      <span
                        className={`${
                          topNav ? "bg-black" : "bg-white"
                        } top cursor-pointer`}
                      ></span>
                      <span
                        className={`${
                          topNav ? "bg-black" : "bg-white"
                        } mid cursor-pointer`}
                      ></span>
                      <span
                        className={`${
                          topNav ? "bg-black" : "bg-white"
                        } bot cursor-pointer`}
                      ></span>
                    </label>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Main Header*/}
      <nav
        className={`w-full py-3 ${
          isScrolled ? "fixed top-0 left-0 shadow-lg z-50" : "relative z-30"
        }`}
        style={{
          background:
            "radial-gradient(circle, rgb(61, 14, 38) 0%, rgb(42, 10, 28) 35%, rgb(56, 1, 32) 70%, rgb(51, 10, 22) 100%)",
        }}
      >
        <div className="flex items-center justify-between ml-7">
          <div className="flex xl:hidden">
            <Link to="/" aria-label="Citrus Diagnostic Center ">
              <img
                src={Logo}
                alt="Citrus Diagnostic Center "
                className="w-[150px] h-auto"
              />
            </Link>
          </div>
          <div className=" mx-auto">
            <ul className="hidden xl:flex items-center gap-5  ">
              <li>
                <Link
                  to="/"
                  aria-label="Home"
                  className="text-white font-medium hover:text-[#4b4b4b] uppercase"
                >
                  Home
                </Link>
              </li>
              <li>
                <HashLink
                  smooth
                  to="/about"
                  className="text-white font-medium hover:text-[#4b4b4b] uppercase"
                >
                  About
                </HashLink>
              </li>
              <div
                className="relative"
                onMouseEnter={handleCompanyMouseEnter}
                onMouseLeave={handleCompanyMouseLeave}
                onFocus={handleCompanyMouseEnter}
                onBlur={handleCompanyMouseLeave}
              >
                <HashLink
                  smooth
                  className=" py-2 font-medium text-white flex items-center hover:text-[#4b4b4b] uppercase"
                  to="/services"
                  onClick={handleCompanyLinkClick}
                >
                  Services
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </HashLink>
                {isImagingOpen && (
                  <div
                    className="fixed left-0 w-full mt-[13px] z-50 text-[#37021f]"
                    onMouseEnter={handleCompanyMouseEnter}
                    onMouseLeave={handleCompanyMouseLeave}
                  >
                    <div className="w-full bg-[#FEECE2] p-6 flex items-center">
                      <div className="w-full lg:w-[90%] 3xl:w-[80%] mx-auto grid grid-cols-2 gap-20 3xl:gap-36 overflow-y-auto">
                        <div>
                          <h3 className="text-xl 2xl:text-2xl font-bold text-[#37021f] mb-10 text-center">
                            Subspecialties
                          </h3>
                          <div className="grid grid-cols-2 gap-0 3xl:gap-10 text-sm 3xl:text-[18px]">
                            <ul className="space-y-2">
                              {SubSpecialitiesInfo.map(
                                (item, index) =>
                                  index % 2 === 0 && (
                                    <li key={index}>
                                      <Link
                                        aria-label={`${item.title} icon`}
                                        to={`/services/subspecialities/${item.slug}`}
                                        className="flex items-center font-semibold hover:opacity-100 opacity-80"
                                        onClick={handleCompanyLinkClick}
                                      >
                                        <img
                                          src={item.menuIcon}
                                          alt={`${item.title}`}
                                          className="w-10 h-10 mr-2"
                                        />
                                        {item.title}
                                      </Link>
                                    </li>
                                  )
                              )}
                            </ul>
                            <ul className="space-y-2">
                              {SubSpecialitiesInfo.map(
                                (item, index) =>
                                  index % 2 !== 0 && (
                                    <li key={index}>
                                      <Link
                                        to={`/services/subspecialities/${item.slug}`}
                                        aria-label={`${item.title} `}
                                        className="flex items-center font-semibold hover:opacity-100 opacity-80"
                                        onClick={handleCompanyLinkClick}
                                      >
                                        <img
                                          src={item.menuIcon}
                                          alt={`${item.title}`}
                                          className="w-10 h-10 mr-2"
                                        />
                                        {item.title}
                                      </Link>
                                    </li>
                                  )
                              )}
                            </ul>
                          </div>
                        </div>
                        <div>
                          <h3 className="text-xl 3xl:text-2xl font-bold text-[#37021f] mb-10 text-center ">
                            Tests
                          </h3>
                          <div className="grid grid-cols-2 gap-5 3xl:gap-10 text-sm 3xl:text-[18px]">
                            <ul className="space-y-2">
                              {ProceduresData.map(
                                (item, index) =>
                                  index % 2 === 0 && (
                                    <li key={index}>
                                      <Link
                                        to={`/services/tests/${item.slug}`}
                                        aria-label={`${item.title}`}
                                        className="flex items-center font-semibold hover:opacity-100 opacity-80"
                                        onClick={handleCompanyLinkClick}
                                      >
                                        <img
                                          src={item.menuIcon}
                                          alt={`${item.title} icon`}
                                          className="w-10 h-10 mr-2"
                                        />
                                        {item.title}
                                      </Link>
                                    </li>
                                  )
                              )}
                            </ul>
                            <ul className="space-y-2">
                              {ProceduresData.map(
                                (item, index) =>
                                  index % 2 !== 0 && (
                                    <li key={index}>
                                      <Link
                                        to={`/services/tests/${item.slug}`}
                                        aria-label={`${item.title}`}
                                        className="flex items-center font-semibold hover:opacity-100 opacity-80"
                                        onClick={handleCompanyLinkClick}
                                      >
                                        <img
                                          src={item.menuIcon}
                                          alt={`${item.title} icon`}
                                          className="w-10 h-10 mr-2"
                                        />
                                        {item.title}
                                      </Link>
                                    </li>
                                  )
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="relative"
                onMouseEnter={handlePatientMouseEnter}
                onMouseLeave={handlePatientMouseLeave}
                onFocus={handlePatientMouseEnter}
                onBlur={handlePatientMouseLeave}
              >
                <Link
                  className=" py-2 font-medium text-white flex items-center hover:text-[#4b4b4b] uppercase"
                  to="/for-patient"
                  onClick={handlePatientLinkClick}
                  aria-label="Patients"
                >
                  Patients
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </Link>
                {isPatientOpen && (
                  <div
                    className="fixed left-0 w-full mt-[13px] z-50"
                    onMouseEnter={handlePatientMouseEnter}
                    onMouseLeave={handlePatientMouseLeave}
                  >
                    <div className="w-full min-h-[350px] bg-[#FEECE2] p-6 flex items-center">
                      <div className="w-[80%] mx-auto grid grid-cols-2 gap-8 justify-items-center font-semibold text-[#37021f] text-sm 3xl:text-[18px]">
                        <ul className="space-y-5">
                          <li>
                            <HashLink
                              to="/for-patient#appointment"
                              className="flex items-center hover:opacity-100 opacity-80"
                              smooth
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("appointment");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={AppointmentIcon}
                                alt="Schedule Appointment"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Request Appointment
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-patient#exam-prep"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("exam-prep");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={ExamPrepIcon}
                                alt="Exam Prep"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Exam Prep
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-patient#forms"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el = document.getElementById("forms");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={PatientFormIcon}
                                alt="Patient Forms"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Patient Forms
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-patient#insurance"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("insurance");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={BillingInsuIcon}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Billing & Insurance
                            </HashLink>
                          </li>
                        </ul>
                        <ul className="space-y-5">
                          <li>
                            <HashLink
                              smooth
                              to="/for-patient#abbadox-portal"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("abbadox-portal");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={abbadox}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Patient Portal
                            </HashLink>
                          </li>

                          <li>
                            <HashLink
                              smooth
                              to="/for-patient#patient-rosource"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("patient-rosource");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={PatientResourceIcon}
                                alt="Patient Resources"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Patient Resources
                            </HashLink>
                          </li>

                          <li>
                            <HashLink
                              smooth
                              to="/patient-reviews"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handlePatientLinkClick}
                            >
                              <img
                                src={ReviewsIcon}
                                alt="Patient Reviews"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Patient Reviews
                            </HashLink>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="relative"
                onMouseEnter={handleCliniciansMouseEnter}
                onMouseLeave={handleCliniciansMouseLeave}
                onFocus={handleCliniciansMouseEnter}
                onBlur={handleCliniciansMouseLeave}
              >
                <Link
                  className=" py-2 font-medium text-white flex items-center hover:text-[#4b4b4b] uppercase"
                  to="/for-clinicians"
                  aria-label="Clinicians"
                  onClick={handleCliniciansLinkClick}
                >
                  Clinicians
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </Link>
                {isCliniciansOpen && (
                  <div
                    className="fixed left-0 w-full mt-[13px] z-50"
                    onMouseEnter={handleCliniciansMouseEnter}
                    onMouseLeave={handleCliniciansMouseLeave}
                  >
                    <div className="w-full min-h-[350px] bg-[#FEECE2] p-6 flex items-center">
                      <div className="w-[80%] mx-auto grid grid-cols-2 gap-8 justify-items-center font-semibold text-[#37021f] text-sm 3xl:text-[18px]">
                        <ul className="space-y-5">
                          <li>
                            <HashLink
                              smooth
                              to="/for-clinicians#form"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handleCliniciansLinkClick}
                            >
                              <img
                                src={PatientFormIcon}
                                alt="Physician Order Form"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Physician Order Form
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-clinicians#abbadox-portal"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("abbadox-portal");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={abbadox}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Physician portal
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-clinicians#abbadox-portal"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("abbadox-portal");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={abbadox}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Clinician portal
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="https://us.synthos.health/"
                              target="_blank"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("abbadox-portal");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={abbadox}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              PACS Portal
                            </HashLink>
                          </li>
                        </ul>
                        <ul className="space-y-5">
                          <li>
                            <HashLink
                              smooth
                              to="/medical-records"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handlePatientLinkClick();
                              }}
                            >
                              <img
                                src={MedicalRecordsIcon}
                                alt="Medical Records"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Medical Records
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/for-clinicians#resources"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handleCliniciansLinkClick}
                            >
                              <img
                                src={cliniansIcon}
                                alt="Clinician Resources"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Clinician Resources
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/attorney"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handleCliniciansLinkClick}
                            >
                              <img
                                src={attornyimg}
                                alt="Satisfaction Survey"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Attorney
                            </HashLink>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="relative"
                onMouseEnter={handleAttorneyMouseEnter}
                onMouseLeave={handleAttorneyMouseLeave}
                onFocus={handleAttorneyMouseEnter}
                onBlur={handleAttorneyMouseLeave}
              >
                <Link
                  className="py-2 font-medium text-white flex items-center hover:text-[#4b4b4b] uppercase"
                  to="/attorney"
                  onClick={handleAttorneyLinkClick}
                  aria-label="Attorney"
                >
                  Attorney
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </Link>
                {isAttorneyOpen && (
                  <div
                    className="fixed left-0 w-full mt-[13px] z-50"
                    onMouseEnter={handleAttorneyMouseEnter}
                    onMouseLeave={handleAttorneyMouseLeave}
                  >
                    <div className="w-full min-h-[350px] bg-[#FEECE2] p-6 flex items-center">
                      <div className="w-[80%] mx-auto grid grid-cols-1 gap-8 justify-items-center font-semibold text-[#37021f] text-sm 3xl:text-[18px]">
                        <ul className="space-y-5">
                          <li>
                            <Link
                              to="/services/subspecialities/personal-injury-imaging"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handleAttorneyLinkClick}
                              aria-label="Refer Patient"
                            >
                              <img
                                src={BodyImagingIcon}
                                alt="Refer Patient"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Auto/peraonal Injury Imaging
                            </Link>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/attorney"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={handleAttorneyLinkClick}
                            >
                              <img
                                src={PatientFormIcon}
                                alt=" Attorney Portal"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Attorney Portal
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              smooth
                              to="/medical-records"
                              className="flex items-center hover:opacity-100 opacity-80"
                              onClick={() => {
                                handleAttorneyLinkClick();
                                setTimeout(() => {
                                  const el =
                                    document.getElementById("abbadox-portal");
                                  if (el)
                                    el.scrollIntoView({ behavior: "smooth" });
                                }, 0);
                              }}
                            >
                              <img
                                src={abbadox}
                                alt="Billing & Insurance"
                                className="w-10 h-10 mr-2"
                              />{" "}
                              Medical Records
                            </HashLink>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Link to="http://www.abbadoxcareflow.com/" target="_black" 
                aria-label="Clinician Login"
                className="relative group inline-block px-8 py-3 rounded-full text-[#bf9c5e] font-robout font-bold bg-transparent overflow-hidden w-[200px]"
              >
                {/* Static border */}
                <span className="absolute inset-0 rounded-full border-2 border-[#bf9c5e] pointer-events-none"></span>
                {/* Rotating gradient strip */}
                <span className="absolute inset-0 rounded-full pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="absolute inset-0 rounded-full rotate-strip"></span>
                  <span className="absolute inset-[4px] rounded-full"></span>
                </span>
                {/* Text animation */}
                <span className="relative block overflow-hidden h-6 w-full text-center">
                  <span className="block w-full text-center transition-transform duration-300 group-hover:-translate-y-full">
                    Clinician Login
                  </span>
                  <span className="block w-full text-center absolute top-full left-0 transition-all duration-300 group-hover:top-0">
                    Clinician Login
                  </span>
                </span>
              </Link>

              <Link to="https://citrusfl.abbadox.com/patientportal/login" target="_black"
                aria-label="Patient Login"
                className="relative group inline-block px-8 py-3 rounded-full text-[#bf9c5e] font-robout font-bold bg-transparent overflow-hidden w-[200px]"
              >
                {/* Static border */}
                <span className="absolute inset-0 rounded-full border-2 border-[#bf9c5e] pointer-events-none"></span>
                {/* Rotating gradient strip */}
                <span className="absolute inset-0 rounded-full pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="absolute inset-0 rounded-full rotate-strip"></span>
                  <span className="absolute inset-[4px] rounded-full"></span>
                </span>
                {/* Text animation */}
                <span className="relative block overflow-hidden h-6 w-full text-center ">
                  <span className="block w-full text-center transition-transform duration-300 group-hover:-translate-y-full">
                    Patient Login
                  </span>
                  <span className="block w-full text-center absolute top-full left-0 transition-all duration-300 group-hover:top-0">
                    Patient Login
                  </span>
                </span>
              </Link>
              <Link
                aria-label="PACS Login"
                to='https://us.synthos.health/'
                target="_blank"
                className="relative group inline-block px-8 py-3 rounded-full text-[#bf9c5e] font-robout font-bold bg-transparent overflow-hidden w-[200px]"
              >
                {/* Static border */}
                <span className="absolute inset-0 rounded-full border-2 border-[#bf9c5e] pointer-events-none"></span>
                {/* Rotating gradient strip */}
                <span className="absolute inset-0 rounded-full pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="absolute inset-0 rounded-full rotate-strip"></span>
                  <span className="absolute inset-[4px] rounded-full"></span>
                </span>
                {/* Text animation */}
                <span className="relative block overflow-hidden h-6 w-full text-center">
                  <span className="block w-full text-center transition-transform duration-300 group-hover:-translate-y-full">
                    PACS
                  </span>
                  <span className="block w-full text-center absolute top-full left-0 transition-all duration-300 group-hover:top-0">
                    PACS
                  </span>
                </span>
              </Link>
            </ul>
          </div>
          <div className=" flex xl:hidden justify-end mr-7">
            <button
              onClick={() => {
                setActiveDropdown(null);
              }}
              aria-label={topNav ? "Close menu" : "Open menu"} // ⭐ FIX HERE
              className="xiubfib vklmzv rounded-full bg-red-400 cursor-pointer z-40"
            >
              <span className="qopmxk rounded-full">
                <span
                  className={`uweytn rounded-full ${
                    topNav ? "bg-white" : "bg-[#bf9c5e]"
                  }`}
                >
                  <span className="vwuewq z-purple rounded-full"></span>
                  <span className="vwuewq z-turquoise rounded-full"></span>
                  <span className="vwuewq z-yellow rounded-full"></span>
                </span>
              </span>
              <span className="qkxjwn rounded-full">
                <span className="static-xt">
                  <label className="menuButton" htmlFor="check">
                    <input
                      type="checkbox"
                      id="check"
                      checked={topNav}
                      onChange={() => {
                        setTopNav(!topNav);
                        setSpecialityValue(null);
                      }}
                    />
                    <span
                      className={`${
                        topNav ? "bg-black" : "bg-white"
                      } top cursor-pointer`}
                    ></span>
                    <span
                      className={`${
                        topNav ? "bg-black" : "bg-white"
                      } mid cursor-pointer`}
                    ></span>
                    <span
                      className={`${
                        topNav ? "bg-black" : "bg-white"
                      } bot cursor-pointer`}
                    ></span>
                  </label>
                </span>
              </span>
            </button>
          </div>
        </div>
        {/* Off Canvas*/}
        <motion.div
          initial={{
            height: 0,
            clipPath: "ellipse(100% 55% at 48% 44%)",
          }}
          animate={{
            height: topNav ? "100vh" : 0,
            clipPath: topNav
              ? [
                  "ellipse(100% 55% at 48% 44%)",
                  "ellipse(100% 80% at 50% 50%)",
                  "inset(0% 0% 0% 0%)",
                ]
              : [
                  "inset(0% 0% 0% 0%)",
                  "ellipse(100% 80% at 50% 50%)",
                  "ellipse(100% 55% at 48% 44%)",
                ],
          }}
          transition={{
            height: {
              type: "spring",
              stiffness: 200,
              damping: 30,
            },
            clipPath: {
              duration: 1.5,
              ease: "easeInOut",
            },
          }}
          className="w-full bg-[#fafaf6] fixed top-0 z-[25] overflow-y-auto xl:overflow-hidden"
        >
          <div className="w-full h-auto lg:h-full flex lg:flex-row flex-col-reverse pt-36">
            <div className="2xl:w-[70%] lg:w-[40%] w-full h-full flex items-end px-8 xl:px-16 pt-14 pb-16 font-robout">
              <motion.div
                variants={containerVariants}
                initial="hidden"
                animate={topNav ? "visible" : "hidden"}
              >
                <motion.p
                  variants={itemVariants}
                  className="text-[#d78558] text-2xl md:text-[1rem] uppercase font-bold lg:font-semibold font-robout tracking-[.2em]"
                >
                  get in touch
                </motion.p>
                <motion.p
                  variants={itemVariants}
                  className="2xl:text-[2.5rem] sm:text-3xl text-xl mt-2 xl:mt-6"
                >
                  <a href="tel:3524508062">(352) 450-8062</a>
                </motion.p>
                <motion.p
                  variants={itemVariants}
                  className="text-lg 2xl:text-4xl font-normal leading-normal mt-5"
                >
                  <Link
                    to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
                    target="blank"
                    aria-label="Address"
                  >
                    922 North Citrus Avenue <br />
                    Crystal River, Florida 34428
                  </Link>
                </motion.p>
              </motion.div>
            </div>
            <div
              onMouseLeave={() => setActiveDropdown(null)}
              className="w-full flex flex-col gap-y-3 xl:pb-0 lg:pb-16 px-8 md:px-16 lg:px-16 lg:pt-0 items-start xl:justify-start justify-end"
            >
              {menuItems.map((item, index) => (
                <div key={item.text} className="relative group">
                  {item.text === "portal" ? (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`3xl:text-[7.5rem] 2xl:text-[5rem] xl:text-[4.8rem] lg:text-[55px] md:text-7xl text-[2.5rem] tracking-[-.05em] xl:leading-[5.5vw] flex transition-all hover:duration-200 font-robout font-black ${
                        activeDropdown === index && item.dropdown
                          ? "text-[#d78558]"
                          : "hover:text-[#d78558]"
                      }`}
                      onClick={() => {
                        if (window.innerWidth > 1024) {
                          handleDropdownToggle(index);
                          setTopNav(false);
                        }
                      }}
                    >
                      {item.chars.map((char, i) => (
                        <motion.span
                          key={`${item.text}-${i}`}
                          custom={i}
                          variants={wordVariants}
                          initial="hidden"
                          animate={topNav ? "visible" : "hidden"}
                          className={char === " " ? "w-4 " : ""}
                        >
                          {char}
                        </motion.span>
                      ))}
                    </a>
                  ) : (
                    <>
                      <Link
                        to={item.link}
                        aria-label="Links"
                        className={`3xl:text-[7.5rem] 2xl:text-[5rem] xl:text-[4.8rem] lg:text-[55px] md:text-7xl text-[2.5rem] tracking-[-.05em] xl:leading-[5.5vw] hidden lg:flex transition-all hover:duration-200 font-robout font-black ${
                          activeDropdown === index && item.dropdown
                            ? "text-[#d78558]"
                            : "hover:text-[#d78558]"
                        }`}
                        onClick={() => {
                          setTopNav(false);
                          handleMouseLeave(index);
                        }}
                        onMouseEnter={() => handleMouseEnter(index)}
                      >
                        {item.chars.map((char, i) => (
                          <motion.span
                            key={`${item.text}-${i}`}
                            custom={i}
                            variants={wordVariants}
                            initial="hidden"
                            animate={topNav ? "visible" : "hidden"}
                          >
                            {char}
                          </motion.span>
                        ))}
                      </Link>
                      <li
                        className={`3xl:text-[7.5rem] 2xl:text-[5.5rem] xl:text-[4.8rem] cursor-pointer lg:text-[55px] lg:hidden md:text-7xl text-[2.5rem] tracking-[-.05em] xl:leading-[5.5vw] flex transition-all hover:duration-200 font-robout font-black ${
                          activeDropdown === index && item.dropdown
                            ? "text-[#d78558]"
                            : "hover:text-[#d78558]"
                        }`}
                        onClick={() => {
                          handleDropdownToggle(index);
                        }}
                      >
                        {item.chars.map((char, i) => {
                          const isLink =
                            item.text === "home" || item.text === "about";
                          const linkPath =
                            item.text === "home"
                              ? "/"
                              : item.text === "about"
                              ? "/about"
                              : "/";
                          const commonProps = {
                            custom: i,
                            variants: wordVariants,
                            initial: "hidden",
                            animate: topNav ? "visible" : "hidden",
                          };
                          return isLink ? (
                            <motion.span
                              key={i + 1}
                              {...commonProps}
                              onClick={() => setTopNav(false)}
                            >
                              <Link to={linkPath} aria-label="linkPath">
                                {char}
                              </Link>
                            </motion.span>
                          ) : (
                            <motion.span key={i + 20} {...commonProps}>
                              {char}
                            </motion.span>
                          );
                        })}
                        {item.dropdown && (
                          <motion.span
                            variants={wordVariants}
                            initial="hidden"
                            animate={topNav ? "visible" : "hidden"}
                            className="ml-2 text-black group-hover:text-[#d78558]"
                          >
                            {activeDropdown === index ? "-" : "+"}
                          </motion.span>
                        )}
                      </li>
                    </>
                  )}
                  {item.dropdown && (
                    <>
                      <motion.div
                        onMouseLeave={() => {
                          setSpecialityValue(null);
                          if (item.text !== "services") {
                            handleMouseLeave(index);
                          }
                        }}
                        onBlur={() => {
                          if (item.text === "services") {
                            handleMouseLeave(index);
                          }
                        }}
                        onClick={() => handleMouseLeave(index)}
                        variants={dropdownVariants}
                        initial="hidden"
                        animate={
                          activeDropdown === index && window.innerWidth >= 1024
                            ? "visible"
                            : "hidden"
                        }
                        className={`${baseClasses} ${visibilityClass} ${getDropdownClass(
                          item
                        )}`}
                        style={{
                          transformOrigin:
                            item.text === "clinicians" ||
                            item.text === "services"
                              ? "top left"
                              : "top right",
                        }}
                      >
                        <img
                          src={pinImage}
                          alt="pin"
                          className={`absolute 2xl:w-16 2xl:h-14 w-12 h-12 ${
                            item.text === "clinicians" ||
                            item.text === "services"
                              ? "2xl:-top-0 top-0 2xl:-left-12 -left-12"
                              : "xl:-top-1 lg:top-20 2xl:-right-12 -right-14"
                          }`}
                          style={{ transform: "rotate(180deg)" }}
                        />
                        {item.dropdown.map((dropdownItem, i) => (
                          <Link
                            key={dropdownItem.text}
                            to={dropdownItem.link}
                            onClick={() => {
                              setTopNav(false);
                            }}
                            onMouseEnter={() => setSpecialityValue(i + 1)}
                            className={`relative flex flex-col 2xl:text-[1.4rem] text-[18px] font-black capitalize text-white hover:text-[#d78558] 3xl:py-1 py-1 cursor-pointer`}
                          >
                            {dropdownItem.text}
                          </Link>
                        ))}
                        {item.text === "services" && specialityValue === 1 && (
                          <div
                            onClick={() => {
                              handleMouseLeave(index);
                              setSpecialityValue(null);
                              setTopNav(false);
                            }}
                            onMouseLeave={() => {
                              setSpecialityValue(null);
                            }}
                            className={`absolute lg:-top-20 xl:top-0 z-50 -right-[250px] 2xl:-right-[285px] ${
                              specialityValue === 1 ? "flex" : "hidden"
                            } rounded-xl py-3 px-4 text-[15px] 2xl:text-lg flex-col gap-1 bg-black text-white font-robout font-black`}
                          >
                            <img
                              className="absolute lg:top-24 xl:top-5 -left-6"
                              src={leftArrow}
                              alt="left arrow png"
                            />
                            {subspeciality.map((item, index) => (
                              <HashLink
                                smooth
                                className="hover:text-[#d78558]"
                                to={item.link}
                                key={index}
                              >
                                {item.name}
                              </HashLink>
                            ))}
                          </div>
                        )}
                        {item.text === "services" && specialityValue === 2 && (
                          <div
                            onClick={() => {
                              handleMouseLeave(index);
                              setSpecialityValue(null);
                              setTopNav(false);
                            }}
                            onMouseLeave={() => {
                              setSpecialityValue(null);
                            }}
                            className={`absolute lg:-top-20 xl:top-10 z-50 -right-[267px] 2xl:-right-[313px] ${
                              specialityValue === 2 ? "flex" : "hidden"
                            } rounded-xl py-3 px-4 text-[15px] 2xl:text-lg flex-col gap-1 bg-black text-white font-robout font-black`}
                          >
                            <img
                              className="absolute lg:top-32 xl:top-2 -left-6"
                              src={leftArrow}
                              alt="left arrow png"
                            />
                            {procedurs.map((item, index) => (
                              <Link
                                className="hover:text-[#d78558]"
                                to={item.link}
                                key={index}
                                aria-label={`${item.name} `}
                              >
                                {item.name}
                              </Link>
                            ))}
                          </div>
                        )}
                      </motion.div>
                      <motion.div
                        variants={mobileDropdownVariants}
                        initial="hidden"
                        animate={
                          activeDropdown === index && window.innerWidth < 1024
                            ? "visible"
                            : "hidden"
                        }
                        className="bg-black text-white font-robout font-black px-2 rounded-3xl w-[80vw] sm:w-[18rem] md:py-1 lg:hidden"
                      >
                        {item.dropdown.map((dropdownItem, i) => {
                          const stayOpenItems = ["Subspecialities", "Tests"];
                          const isStayOpenItem = stayOpenItems.includes(
                            dropdownItem.text
                          );
                          return (
                            <div key={i}>
                              {isStayOpenItem ? (
                                <div className="text-[1.4rem] font-black w-11/12 flex flex-col capitalize text-white px-2 py-1 md:p-1 cursor-default">
                                  <p
                                    onClick={() => {
                                      setSubDropDown(i);
                                      setActiveSubDropDown((prev) =>
                                        prev === i ? null : i
                                      );
                                    }}
                                    className="flex items-center gap-1 my-1"
                                  >
                                    {dropdownItem.text}
                                    <KeyboardArrowDownIcon
                                      className={`transition-all duration-200 ${
                                        subDropDown === i &&
                                        activeSubDropDown === i
                                          ? "rotate-180"
                                          : ""
                                      }`}
                                    />
                                  </p>
                                  {subDropDown === i &&
                                    activeSubDropDown === i && (
                                      <div
                                        onMouseLeave={() =>
                                          handleMouseLeave(index)
                                        }
                                        className="flex text-xl flex-col w-full py-2 px-6 border text-white rounded-xl m-2"
                                      >
                                        {dropdownItem.text ===
                                          "Subspecialities" &&
                                          subspeciality.map((item, index) => (
                                            <HashLink
                                              key={index}
                                              onClick={() => {
                                                setSubDropDown(null);
                                                setActiveSubDropDown(null);
                                                setTopNav(false);
                                                handleDropdownToggle(index);
                                              }}
                                              to={item.link}
                                              className="hover:text-[#d78558]"
                                            >
                                              {item.name}
                                            </HashLink>
                                          ))}
                                        {dropdownItem.text === "Tests" &&
                                          procedurs.map((item, index) => (
                                            <HashLink
                                              onClick={() => {
                                                setSubDropDown(null);
                                                setActiveSubDropDown(null);
                                                setTopNav(false);
                                                handleDropdownToggle(index);
                                              }}
                                              key={index}
                                              to={item.link}
                                              className="hover:text-[#d78558]"
                                            >
                                              {item.name}
                                            </HashLink>
                                          ))}
                                      </div>
                                    )}
                                </div>
                              ) : dropdownItem.link.startsWith("http") ? (
                                <a
                                  href={dropdownItem.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-[1.4rem] font-black w-4/5 flex flex-col capitalize text-white px-2 py-1 md:p-1 hover:text-[#d78558] cursor-pointer"
                                  onClick={() => {
                                    handleDropdownToggle(index);
                                    setTopNav(false);
                                  }}
                                >
                                  {dropdownItem.text}
                                </a>
                              ) : (
                                <HashLink
                                  to={dropdownItem.link}
                                  onClick={() => {
                                    handleDropdownToggle(index);
                                    setTopNav(false);
                                  }}
                                  className="text-[1.4rem] font-black w-4/5 flex flex-col capitalize text-white px-2 py-1 md:p-1 hover:text-[#d78558] cursor-pointer"
                                >
                                  {dropdownItem.text}
                                </HashLink>
                              )}
                            </div>
                          );
                        })}
                      </motion.div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </nav>
    </div>
  );
}
